<template>
	<layout-admin-auto-loading class="admin-service-list" :loader="getServices" :loading="loading" :finished="finished" :error="error">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<div slot="header" class="slot">
			<h1>{{ title }}</h1>
			<button-icon-text :to="{ name: 'AdminServiceAdd' }" icon="plus-w" class="plus btn-add">Add Service</button-icon-text>
		</div>
		<div slot="body">
			<admin-data-table :finished="finished" :table_columns="table_columns" :table_rows="table_rows"/>
		</div>
	</layout-admin-auto-loading>
</template>

<script>
import LayoutAdminAutoLoading from '../LayoutAdminAutoLoading'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
import AdminDataTable from '../AdminDataTable'
export default {
	components: {
		LayoutAdminAutoLoading,
		AdminBreadcrumbs,
		AdminDataTable
	},
	data () {
		return {
			vue: this,
			title: 'Service List',
			loading: false,
			error: null,
			data: [],
			finished: false,
			limit: 20,
			table_columns: [
				{
					label: '#',
					field: 'id',
					width: '75px'
				},
				{
					label: 'Name',
					field: 'name'
				},
				{
					label: 'Description',
					field: 'description'
				},
				{
					label: 'Monthly Price',
					field: 'monthly_price_unity',
					width: '100px'
				},
				{
					label: 'Yearly Price',
					field: 'yearly_price_unity',
					width: '100px'
				},
				{
					label: 'Visible',
					field: 'visible',
					width: '75px'
				},
				{
					label: 'Date',
					field: 'create_time',
					width: '100px'
				},
				{
					label: '',
					width: '75px'
				}
			]
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: this.title
				}
			]
		},
		offset () {
			return this.data.length
		},
		table_rows () {
			return this.data.map(row => {
				return {
					columns: [
						{ field: 'id', value: row.id },
						{ field: 'name', value: row.name },
						{ field: 'description', value: row.description },
						{ field: 'monthly_price_unity', value: `${row.monthly_price_unity} €` },
						{ field: 'yearly_price_unity', value: `${row.yearly_price_unity} €` },
						{ field: 'visible', value: row.visible ? 'Yes' : 'No' },
						{ field: 'create_time', value: this.$moment(row.create_time).format('L') },
						{
							field: 'operation',
							type: 'operation',
							value: { title: 'Edit', to: { name: 'AdminServiceEdit', params: { service_id: row.id, data: row } } }
						}
					]
				}
			})
		}
	},
	methods: {
		getServices () {
			this.loading = true
			this.$api.subscriptions.services.admin.getAll(this, this.offset, this.limit).then(response => {
				this.$log.info('admin', 'subscriptions.services.admin.getAll OK', response)()
				if (response.body.length) {
					this.data = this.data.concat(response.body)
				}
				if (!response.body.length || response.body.length < this.limit) {
					this.finished = true
				}
			}).catch(errors => {
				this.$log.error('admin', 'subscriptions.services.admin.getAll ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.loading = false
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/services/ServiceList.vue